"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BalanceDefinitionConversionRate = _interopRequireDefault(require("./BalanceDefinitionConversionRate"));
var _BalanceDefinitionDisplayDetail = _interopRequireDefault(require("./BalanceDefinitionDisplayDetail"));
var _BalanceDefinitionTag = _interopRequireDefault(require("./BalanceDefinitionTag"));
var _Catalog = _interopRequireDefault(require("./Catalog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The BalanceDefinition model module.
 * @module model/BalanceDefinition
 * @version 3.0
 */
var BalanceDefinition = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>BalanceDefinition</code>.
   * @alias module:model/BalanceDefinition
   */
  function BalanceDefinition() {
    _classCallCheck(this, BalanceDefinition);
    BalanceDefinition.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(BalanceDefinition, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>BalanceDefinition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BalanceDefinition} obj Optional instance to populate.
     * @return {module:model/BalanceDefinition} The populated <code>BalanceDefinition</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new BalanceDefinition();
        if (data.hasOwnProperty('balanceDefinitionId')) {
          obj['balanceDefinitionId'] = _ApiClient["default"].convertToType(data['balanceDefinitionId'], 'Number');
        }
        if (data.hasOwnProperty('balanceDefinitionLegacyId')) {
          obj['balanceDefinitionLegacyId'] = _ApiClient["default"].convertToType(data['balanceDefinitionLegacyId'], 'String');
        }
        if (data.hasOwnProperty('catalog')) {
          obj['catalog'] = _Catalog["default"].constructFromObject(data['catalog']);
        }
        if (data.hasOwnProperty('subCatalog')) {
          obj['subCatalog'] = _Catalog["default"].constructFromObject(data['subCatalog']);
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('displayName')) {
          obj['displayName'] = _ApiClient["default"].convertToType(data['displayName'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('units')) {
          obj['units'] = _ApiClient["default"].convertToType(data['units'], 'String');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('rank')) {
          obj['rank'] = _ApiClient["default"].convertToType(data['rank'], 'Number');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], [_BalanceDefinitionTag["default"]]);
        }
        if (data.hasOwnProperty('displayDetails')) {
          obj['displayDetails'] = _ApiClient["default"].convertToType(data['displayDetails'], [_BalanceDefinitionDisplayDetail["default"]]);
        }
        if (data.hasOwnProperty('conversionRates')) {
          obj['conversionRates'] = _ApiClient["default"].convertToType(data['conversionRates'], [_BalanceDefinitionConversionRate["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BalanceDefinition</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BalanceDefinition</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['balanceDefinitionLegacyId'] && !(typeof data['balanceDefinitionLegacyId'] === 'string' || data['balanceDefinitionLegacyId'] instanceof String)) {
        throw new Error("Expected the field `balanceDefinitionLegacyId` to be a primitive type in the JSON string but got " + data['balanceDefinitionLegacyId']);
      }
      // validate the optional field `catalog`
      if (data['catalog']) {
        // data not null
        _Catalog["default"].validateJSON(data['catalog']);
      }
      // validate the optional field `subCatalog`
      if (data['subCatalog']) {
        // data not null
        _Catalog["default"].validateJSON(data['subCatalog']);
      }
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['displayName'] && !(typeof data['displayName'] === 'string' || data['displayName'] instanceof String)) {
        throw new Error("Expected the field `displayName` to be a primitive type in the JSON string but got " + data['displayName']);
      }
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['units'] && !(typeof data['units'] === 'string' || data['units'] instanceof String)) {
        throw new Error("Expected the field `units` to be a primitive type in the JSON string but got " + data['units']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      if (data['tags']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['tags'])) {
          throw new Error("Expected the field `tags` to be an array in the JSON data but got " + data['tags']);
        }
        // validate the optional field `tags` (array)
        var _iterator = _createForOfIteratorHelper(data['tags']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _BalanceDefinitionTag["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['displayDetails']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['displayDetails'])) {
          throw new Error("Expected the field `displayDetails` to be an array in the JSON data but got " + data['displayDetails']);
        }
        // validate the optional field `displayDetails` (array)
        var _iterator2 = _createForOfIteratorHelper(data['displayDetails']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _BalanceDefinitionDisplayDetail["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['conversionRates']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['conversionRates'])) {
          throw new Error("Expected the field `conversionRates` to be an array in the JSON data but got " + data['conversionRates']);
        }
        // validate the optional field `conversionRates` (array)
        var _iterator3 = _createForOfIteratorHelper(data['conversionRates']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _BalanceDefinitionConversionRate["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} balanceDefinitionId
 */
BalanceDefinition.prototype['balanceDefinitionId'] = undefined;

/**
 * @member {String} balanceDefinitionLegacyId
 */
BalanceDefinition.prototype['balanceDefinitionLegacyId'] = undefined;

/**
 * @member {module:model/Catalog} catalog
 */
BalanceDefinition.prototype['catalog'] = undefined;

/**
 * @member {module:model/Catalog} subCatalog
 */
BalanceDefinition.prototype['subCatalog'] = undefined;

/**
 * @member {String} type
 */
BalanceDefinition.prototype['type'] = undefined;

/**
 * @member {String} displayName
 */
BalanceDefinition.prototype['displayName'] = undefined;

/**
 * @member {String} description
 */
BalanceDefinition.prototype['description'] = undefined;

/**
 * @member {String} units
 */
BalanceDefinition.prototype['units'] = undefined;

/**
 * @member {String} currency
 */
BalanceDefinition.prototype['currency'] = undefined;

/**
 * @member {Number} rank
 */
BalanceDefinition.prototype['rank'] = undefined;

/**
 * @member {String} category
 */
BalanceDefinition.prototype['category'] = undefined;

/**
 * @member {Array.<module:model/BalanceDefinitionTag>} tags
 */
BalanceDefinition.prototype['tags'] = undefined;

/**
 * @member {Array.<module:model/BalanceDefinitionDisplayDetail>} displayDetails
 */
BalanceDefinition.prototype['displayDetails'] = undefined;

/**
 * @member {Array.<module:model/BalanceDefinitionConversionRate>} conversionRates
 */
BalanceDefinition.prototype['conversionRates'] = undefined;
var _default = exports["default"] = BalanceDefinition;